import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import LanguageContext from '../../../contexts/languageContext';
const styles = makeStyles((props) => ({
    container: {
        display: 'flex',
        '& > div': {
            marginLeft: props.rtl ? '-10px' : '0',
            marginRight: props.rtl ? '0' : '-10px',
            '&:last-child': {
                marginLeft: '0'
            }
        }
    },
    item: (props) => ({
        position: 'relative',
        minWidth: '100px',
        display: 'flex',
        flex: 'auto',
        justifyContent: 'center',
        alignItems: 'center',
        borderTopLeftRadius: props.rtl ? '23px' : '0',
        borderTopRightRadius: props.rtl ? '0' : '23px',
        borderBottomLeftRadius: props.rtl ? '23px' : '0',
        borderBottomRightRadius: props.rtl ? '0' : '23px',
        height: '40px',
        padding: '8px 7px 7px',
        color: '#767676',
        backgroundColor: 'white',
        boxShadow: '-3px 3px 6px 0 rgba(54, 54, 54, 0.17)',
        '&:hover': {
            cursor: 'pointer'
        }
    }),
    active: {
        color: '#1b90fa !important',
        backgroundColor: '#d5ebff !important'
    }
}));

export default function Stepper({ stepperItems, activeStep, handleClick }) {
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    return (
        <div className={classes.container}>
            {stepperItems.map((item) => (
                <div
                    key={item.status}
                    className={
                        item.status === activeStep
                            ? `${classes.item} ${classes.active}`
                            : classes.item
                    }
                    style={{ zIndex: 10 - item.status }}
                    onClick={() => handleClick(item.status)}
                >
                    {item.name}
                </div>
            ))}
        </div>
    );
}
Stepper.propTypes = {
    stepperItems: PropTypes.array,
    activeStep: PropTypes.bool,
    handleClick: PropTypes.func
};
